import { createAction } from '@reduxjs/toolkit';

export const NAV_STACK_REBASE_ACTION_TYPE = 'saga/navStackRebase';
export const navStackRebaseAction = createAction(NAV_STACK_REBASE_ACTION_TYPE);
